import { createContext, useContext } from 'react';

/**
 * Titelgegevens van de huidige route (uit Layout → ROUTE_BANNERS). Schillen met
 * een ZijMenu tonen deze als PaginaKop in de inhoudskolom i.p.v. een banner
 * boven de pagina.
 */
export interface PaginaBanner {
  label: string;
  title: string;
  subtitle?: string;
}

export const PaginaBannerContext = createContext<PaginaBanner | null>(null);

export const usePaginaBanner = () => useContext(PaginaBannerContext);
